import React, { useContext, memo } from 'react';
import { PageContext } from '@/components/providers/page-provider/PageProvider';
import PageSettingsWrapper from './page-settings-wrapper/PageSettingsWrapper';
import Tabs from '../tabs/Tabs.jsx';
import c from './page-nav.module.scss';

const PageNav = memo(({ navMiddleRef }) => {
  const { pages } = useContext(PageContext);

  return pages ? (
    <div className={c.pageNav} role="navigation" aria-label="Pages">
      <Tabs navMiddleRef={navMiddleRef} />
      <PageSettingsWrapper />
    </div>
  ) : null;
});
export default PageNav;
